<script lang="ts">
    import type { ITrxCheque } from '../../order'
    import Icon from '@iconify/svelte'

    import Date from 'hydria/components/Date.svelte'

    interface Props {
        trx: ITrxCheque
    }

    let { trx }: Props = $props()

    let expandTransaction = $state(false)
    let expandQuery = $state(false)
</script>

<h4>Chèque</h4>

<table class="table">
    <caption>Transaction <button type="button" class="btn btn-sm btn-outline-secondary float-end" class:active={expandTransaction} onclick={() => (expandTransaction = !expandTransaction)}><Icon inline icon="fa:arrows-v" /></button></caption>
    <tbody>
        <tr><th>Statut</th><td>{trx.status}</td></tr>
        {#if expandTransaction}
            <tr><th>Méthode</th><td>{trx.payment_method}</td></tr>
            <tr><th>Date</th><td><Date value={trx.stamp} format="h-table" /></td></tr>
            <tr><th>Address IP</th><td>{trx.ip_address}</td></tr>
            <tr><th>ID</th><td>{trx.id}</td></tr>
        {/if}
    </tbody>
</table>

<table class="table">
    <caption>Chèque <button type="button" class="btn btn-sm btn-outline-secondary float-end" class:active={expandQuery} onclick={() => (expandQuery = !expandQuery)}><Icon inline icon="fa:arrows-v" /></button></caption>
    <tbody>
        <tr><th>Nom sur le chèque</th><td>{trx.data.cheque.name_on_cheque}</td></tr>
        <tr><th>No de chèque</th><td>{trx.data.cheque.number}</td></tr>
        <tr><th>Date du chèque</th><td><Date value={trx.data.cheque.date} format="h-table" /></td></tr>
        {#if expandQuery}
            <tr><th>Montant</th><td>{trx.data.cheque.amount}</td></tr>
        {/if}
    </tbody>
</table>
